import { Component, ojs, app, State, payload, v } from "modular-openscriptjs";
import { monetary, formatThousand, cleanDispose, either } from "../../helpers";
import { tool, dom } from "../../fotastart";
import { gc, uc } from "../../declarations";

// Components
import ProfilePic from "../ProfilePic";
import MoreOptions from "../Blocks/MoreOptions";
import ProductImageView from "./ProductImageView";

const h = app("h");
const broker = app("broker");
const route = app("router");
const $e = app("$e");

ojs(ProfilePic, MoreOptions, ProductImageView);

export default class RelatedProductView extends Component {
	imagesModal = null;

	render(productState, ...args) {
		let product = productState;

		if (productState instanceof State) {
			product = productState.value;
		}

		if (!product?.id) return h.empty();

		let user = product?.owner;

		if (product?.is_copied) {
			user = product?.copier;
		}

		return h.div(
			{
				class: "d-flex p-0 gap-0 position-relative flex-column justify-content-between h-100",
				data_product_id: product?.id,
				$data_product_id: product?.id,
			},

			// Header: User Info & Options
			h.div(
				{
					class: "d-flex mb-3 p-0 gap-2 position-relative align-items-center",
				},
				h.div(
					{ class: "position-relative flex-shrink-0" },
					h.ProfilePic(gc.user, {
						class: "rounded-circle d-block border border-light-subtle shadow-sm",
						style: "width: 32px; height: 32px; object-fit: cover;",
					}),
					h.div(
						{
							class: "position-absolute bottom-0 end-0 bg-white rounded-circle p-0 d-flex align-items-center justify-content-center",
							style: "width: 12px; height: 12px;",
						},
						either(
							user?.is_business,
							() =>
								h.i({
									class: "fas fa-shop text-info",
									style: "font-size: 8px;",
								}),
							either(user?.is_verified, () =>
								h.i({
									class: "fas fa-circle-check text-info",
									style: "font-size: 8px;",
								})
							)
						)
					)
				),
				h.div(
					{
						class: "d-flex gap-2 justify-content-between flex-fill align-items-center",
					},
					h.div(
						{
							class: "text-truncate",
							role: "button",
							onclick: h.func("route.to", "user.view-profile", {
								user:
									user?.id == gc.user?.id
										? "current"
										: user?.id,
							}),
							style: "max-width: 120px;",
						},
						h.div(
							{
								class: "m-0 text-truncate fw-bold text-dark fs-xsm",
							},
							either(
								user?.display_name?.length > 15,
								user?.display_name?.substring(0, 15) + "...",
								user?.display_name
							)
						),

						h.div(
							{
								class: "text-secondary d-block text-truncate fs-xxsm",
							},
							"@",
							user?.username
						)
					),

					h.div(
						{
							role: "button",
						},
						h.MoreOptions([
							null,
							h.ul(
								{ class: "list-unstyled m-0" },
								either(
									(product.owner_id == gc.user?.id &&
										product.pivot?.user_id ==
											gc.user?.id) ||
										(gc.user?.id ==
											product.pivot?.user_id &&
											gc.user?.id == user?.id &&
											product.parent_product != null),
									() =>
										h.li(
											h.div(
												{
													role: "button",
													class: "dropdown-item btn-icon-text gap-2 px-3 py-2",
													onclick: this.method(
														"editProduct",
														product
													),
													title: "Edit Product",
												},
												h.i({
													class: "fa-solid fa-pen text-secondary w-20px",
												}),
												h.span("Edit")
											)
										)
								),

								either(product.owner_id == gc.user?.id, () =>
									h.li(
										h.div(
											{
												role: "button",
												class: "dropdown-item btn-icon-text gap-2 px-3 py-2",
												onclick: this.method(
													"copyProduct",
													product
												),
												title: "Copy Product",
											},
											h.i({
												class: "fa-solid fa-copy text-secondary w-20px",
											}),
											h.span("Copy & Edit")
										)
									)
								),
								either(
									product.owner_id != gc.user?.id &&
										product.is_copyable == 1,
									() =>
										h.li(
											h.div(
												{
													role: "button",
													class: "dropdown-item btn-icon-text gap-2 px-3 py-2",
													onclick: this.method(
														"copyProduct",
														product
													),
													title: "Clone Product",
												},
												h.i({
													class: "fa-solid fa-copy text-secondary w-20px",
												}),
												h.span("Clone & Edit")
											)
										)
								),
								either(
									product.is_private == 0 ||
										(gc.user.id == user?.id &&
											product.owner_id == gc.user.id &&
											product.pivot?.user_id == user?.id),
									() => [
										h.li(
											h.div(
												{
													role: "button",
													class: "dropdown-item btn-icon-text gap-2 px-3 py-2",
													title: "Share on WhatsApp",
													onclick: this.method(
														"shareProduct",
														product
													),
												},
												h.i({
													class: "fa-brands fa-whatsapp text-success w-20px",
												}),
												h.span("Share")
											)
										),

										h.li(
											h.div(
												{
													role: "button",
													class: "dropdown-item btn-icon-text gap-2 px-3 py-2",
													title: "Share via QR",
													onclick: this.method(
														"showQrCode",
														product
													),
												},
												h.i({
													class: "fas fa-qrcode text-dark w-20px",
												}),
												h.span("QR Code")
											)
										),
									]
								),

								either(
									(!route.is("user.view-cart") &&
										product.owner_id == gc.user?.id &&
										product.pivot?.user_id ==
											gc.user?.id) ||
										(gc.user?.id ==
											product.pivot?.user_id &&
											gc.user?.id == user?.id &&
											product.parent_product != null),
									() =>
										h.li(
											h.div(
												{
													role: "button",
													class: "dropdown-item dropdown-item-danger btn-icon-text gap-2 px-3 py-2 text-danger",
													title: "Delete Product",
													onclick: this.method(
														"deleteProduct",
														product
													),
												},
												h.i({
													class: "fa-solid fa-trash-can w-20px",
												}),
												h.span("Delete")
											)
										)
								)
							),
						])
					)
				)
			),

			// Content: Name, Desc, Price
			h.div(
				{
					class: "d-flex flex-column mb-3 text-start flex-fill justify-content-end",
				},

				h.div(
					{
						class: "mb-1 fw-bold text-dark lh-sm text-truncate-2",
						onclick: h.func("route.to", "product.view-product", {
							productId: product?.id,
							u: user?.id,
						}),
						role: "button",
					},
					product?.name
				),

				either(product?.images?.length, () =>
					h.div(
						{
							class: "mb-2 position-relative",
							role: "button",
							onclick: this.method("seeImages", [
								product?.images,
							]),
						},
						h.img({
							src:
								product?.images[0]?.path ||
								product?.images[0]?.url ||
								product?.images[0],
							class: "w-100 rounded-3 object-fit-cover border border-light-subtle",
							style: "height: 140px;",
							loading: "lazy",
							alt: product?.name,
						}),
						either(product?.images?.length > 1, () =>
							h.span(
								{
									class: "position-absolute bottom-0 end-0 m-2 badge bg-dark bg-opacity-75 rounded-pill fs-xxsm fw-medium backdrop-blur-sm",
								},
								h.i({ class: "fas fa-images me-1" }),
								product.images.length
							)
						)
					)
				),

				h.div(
					{
						class: "d-flex gap-2 align-items-baseline fs-sm",
						onclick: h.func("route.to", "product.view-product", {
							productId: product?.id,
							u: user?.id,
						}),
						role: "button",
					},
					h.span(
						either(
							product?.discounted_price &&
								product?.discounted_price < product?.price,
							{
								class: "text-secondary text-decoration-line-through fs-xsm",
							},
							{ class: "text-primary fw-bold" }
						),
						"≈",
						monetary(product?.price, userCurrency)
					),

					either(
						product?.discounted_price &&
							product?.discounted_price < product?.price,
						() =>
							h.span(
								{ class: "text-success fw-bold" },
								monetary(
									product?.discounted_price,
									userCurrency
								)
							)
					)
				)
			),

			// Footer: Stats & Actions
			h.div(
				{
					class: "d-flex justify-content-between align-items-center gap-2 pt-2 border-top border-light-subtle",
				},

				h.div(
					{
						class: "d-flex gap-3 text-secondary fs-xsm",
					},
					h.span(
						{
							class: "d-flex gap-1 align-items-center cursor-pointer",
						},
						either(
							product?.current_like &&
								product?.current_like.length,
							() => [
								h.i({
									class: "fas fa-heart text-danger animated-icon animated-add",
								}),
								{ onclick: this.method("unlike", product) },
							],
							() => [
								h.i({
									class: "far fa-heart animated-icon animated-remove",
								}),
								{ onclick: this.method("like", product) },
							]
						),
						formatThousand(product?.like_count)
					),

					h.span(
						{
							class: "d-flex gap-1 align-items-center",
						},
						h.i({ class: "far fa-clipboard" }),
						formatThousand(product?.carted_count)
					)
				),

				h.div(
					{
						class: "d-flex gap-2",
					},
					either(
						product?.chat_to_order,
						() =>
							h.button(
								{
									class: "btn btn-sm btn-outline-success rounded-circle d-flex align-items-center justify-content-center shadow-sm p-0",
									style: "width: 32px; height: 32px;",
									onclick: this.method(
										"initiateChatOrder",
										product.id
									),
								},
								h.i({
									class: "fa-brands fa-whatsapp fs-sm",
								})
							),
						() =>
							v(uc.cartMap, (cartMap) => {
								return either(
									product?.id in cartMap.value,
									() => {
										return h.button(
											{
												class: "btn btn-sm btn-primary rounded-circle d-flex align-items-center justify-content-center shadow-sm p-0",
												style: "width: 32px; height: 32px;",
												onclick: h.func(
													"route.to",
													"user.view-cart"
												),
											},
											h.i({
												class: "fas fa-shopping-cart fs-sm",
											})
										);
									},
									() => {
										return h.button(
											{
												class: "btn btn-sm btn-light border rounded-circle d-flex align-items-center justify-content-center shadow-sm p-0",
												style: "width: 32px; height: 32px;",
												onclick: this.method(
													"editProduct",
													product
												),
											},
											h.i({
												class: "fas fa-pen fs-sm text-dark",
											})
										);
									}
								);
							})
					),

					either(!product?.chat_to_order, () =>
						h.button(
							{
								class: "btn btn-sm btn-primary rounded-pill px-3 shadow-sm d-flex align-items-center gap-1",
								onclick: this.method("addToCart", product),
								// See Product::is_available on the backend
								// (App\Services\AvailabilityService).
								...either(product?.is_available === false, {
									disabled: "disabled",
									class: "btn btn-sm btn-light border rounded-pill px-3 shadow-sm d-flex align-items-center gap-1 text-muted",
								}),
							},

							h.span(
								{ class: "fw-bold fs-xsm" },
								either(
									product?.is_available === false,
									h.call(() => "Closed"),
									() =>
										v(uc.cartMap, (cartMap) => {
											return either(
												product?.id in cartMap.value,
												h.call(() =>
													h.span(
														{
															class: "d-flex align-items-center gap-1",
														},
														h.i({ class: "fas fa-check" }),
														cartMap.value[product?.id]?.item
															?.qty
													)
												),
												h.call(() => [
													h.i({ class: "fas fa-plus me-1" }),
													"Add",
												])
											);
										})
								)
							)
						)
					)
				)
			),

			...args
		);
	}

	seeImages(images) {
		if (this.imagesModal) {
			cleanDispose(this.imagesModal);
		}

		this.imagesModal = tool.plainModal(
			h.div(
				{
					class: "modal-content border-0 w-auto mx-auto bg-transparent shadow-none",
				},
				h.div({ class: "modal-body p-0" }, h.ProductImageView(images))
			),
			{}
		);

		this.imagesModal.show();
	}

	addToCart(product) {
		if (product.id in uc.cartMap.value) {
			return this.updateItem(uc.cartMap.value[product.id].item);
		}

		broker.broadcast($e.cart.itemSelected, payload({ item: product }));
	}

	editProduct(product) {
		broker.send($e.product.needs.update, payload({ item: product }));
	}

	updateItem(item) {
		broker.send($e.cart.needs.itemUpdateForm, payload({ item }));
	}

	deleteProduct(product) {
		broker.send($e.product.needs.deletion, payload({ id: product.id }));
	}

	shareProduct(product) {
		broker.send(
			$e.product.needs.share,
			payload({ id: product.id, product })
		);
	}

	copyProduct(product) {
		product.original_product_id = product.id;
		delete product.id;
		broker.send($e.product.needs.creation, payload({ item: product }));
	}

	removeItem(item) {
		broker.send($e.cart.needs.itemRemoval, payload({ rowId: item?.rowId }));
	}

	like(product) {
		broker.send($e.product.needs.like, payload({ product }));
	}

	unlike(product) {
		broker.send($e.product.needs.unlike, payload({ product }));
	}

	initiateChatOrder(productId) {
		broker.send(
			$e.user.needs.to.orderViaChat,
			payload({ order_product_id: productId })
		);
	}

	showQrCode(product) {
		broker.send(
			$e.qr.needs.code,
			payload({
				title: `${product.name} - Item QR Code`,
				data: `/products/${product?.id}/view`,
			})
		);
	}

	cleanUp() {
		super.cleanUp();
		cleanDispose(this.imagesModal);
	}
}
